import { createAction } from '@reduxjs/toolkit';

export const addedLessonToCourse = createAction<{
    containerSlug: string | null;
    courseId: number | null;
    teamId: number | null;
}>('LESSON/addedLessonToCourse');
